import { ZoomIn } from '@material-ui/icons';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext } from 'react';
import { AppContext } from '../../../state/app.state';
import { isMobile } from '../../../utils/app.helper';
import './KeynoardInfo.scss';

type KeyboardInfoProps={
};

const KeyboardInfo: React.FC<KeyboardInfoProps> = (): ReactElement => {
    const { presentationState } = useContext(AppContext);

    return useObserver(() => (
        <>
            {!isMobile() && presentationState?.showKeyboardInfo &&
            <div className={'bv-keyboard-info'}>
                <ZoomIn className={'bv-onboarding-options'}/>: alt + scroll
            </div>}
        </>
    ));
};


export default KeyboardInfo;